/** @jsx jsx */

import { Button, Media } from '@zapier/common-components';
import { Colors } from '@zapier/theme';
import {
  LOGIN_URL,
  SIGNUP_URL,
} from '@zapier/product-dev-platform/src/constants';
import { jsx, Interpolation } from '@emotion/core';

const ctaButtonsCss: Interpolation = {
  display: 'flex',
  '@media (max-width: 1079px)': {
    justifyContent: 'space-around',
    flexDirection: 'row-reverse',
    borderBottom: `1px solid ${Colors.adamantium}`,
    padding: '1.5em',
  },
  a: {
    marginLeft: 8,
    '&:hover': {
      // Overwrite some global styles in web
      textDecoration: 'none',
    },
  },
};

function CtaButtons() {
  return (
    <Media queries={{ small: '(max-width: 1079px)' }}>
      {({ small }: { small: boolean }) => (
        <nav css={ctaButtonsCss}>
          <Button
            color={!small ? 'platformDark' : 'secondary'}
            hoverInvert={!small}
            href={LOGIN_URL}
            isFullWidth={small}
            isSlim={!small}
            size="medium"
          >
            Log In
          </Button>
          <Button
            color="important"
            href={SIGNUP_URL}
            isFullWidth={small}
            isSlim={!small}
            size="medium"
          >
            Sign Up
          </Button>
        </nav>
      )}
    </Media>
  );
}

export default CtaButtons;
